"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require("babel-runtime/helpers/extends");

var _extends4 = _interopRequireDefault(_extends3);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _bluebird = require("bluebird");

var _bluebird2 = _interopRequireDefault(_bluebird);

var _reactRedux = require("react-redux");

var _redial = require("redial");

var _glamor = require("glamor");

var _reactRouter = require("react-router");

var _subscriptions = require("redux/modules/subscriptions");

var _payments = require("redux/modules/payments");

var _customer = require("redux/modules/customer");

var _user = require("redux/modules/user");

var userActions = _interopRequireWildcard(_user);

var _faq2 = require("data/pricing/faq");

var _faq3 = _interopRequireDefault(_faq2);

var _underscore = require("underscore");

var _underscore2 = _interopRequireDefault(_underscore);

var _ItemWithImageDescriptionAndIcons = require("@quixeltools/quixel-ui-library/dist/components/common/website/ItemWithImageDescriptionAndIcons");

var _ItemWithImageDescriptionAndIcons2 = _interopRequireDefault(_ItemWithImageDescriptionAndIcons);

var _PageTitleWithBackground = require("@quixeltools/quixel-ui-library/dist/components/common/website/PageTitleWithBackground");

var _PageTitleWithBackground2 = _interopRequireDefault(_PageTitleWithBackground);

var _PricingHeader = require("@quixeltools/quixel-ui-library/dist/components/quixel/website/PricingHeader");

var _PricingHeader2 = _interopRequireDefault(_PricingHeader);

var _Columns = require("@quixeltools/quixel-ui-library/dist/components/common/website/Columns");

var _Columns2 = _interopRequireDefault(_Columns);

var _PlansComparison = require("@quixeltools/quixel-ui-library/dist/components/megascans/subscriptions/PlansComparison");

var _PlansComparison2 = _interopRequireDefault(_PlansComparison);

var _Section = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/Section");

var _Section2 = _interopRequireDefault(_Section);

var _CompanyListing = require("@quixeltools/quixel-ui-library/dist/components/common/website/CompanyListing");

var _CompanyListing2 = _interopRequireDefault(_CompanyListing);

var _Select = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Select");

var _Select2 = _interopRequireDefault(_Select);

var _Link = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Link");

var _Link2 = _interopRequireDefault(_Link);

var _Radio = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Radio");

var _Radio2 = _interopRequireDefault(_Radio);

var _HowPointsWork = require("@quixeltools/quixel-ui-library/dist/components/megascans/marketing/HowPointsWork");

var _HowPointsWork2 = _interopRequireDefault(_HowPointsWork);

var _FAQSummary = require("@quixeltools/quixel-ui-library/dist/components/megascans/marketing/FAQSummary");

var _FAQSummary2 = _interopRequireDefault(_FAQSummary);

var _Tabs = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Tabs");

var _Tabs2 = _interopRequireDefault(_Tabs);

var _fonts = require("@quixeltools/quixel-ui-library/dist/utils/fonts");

var _components = require("components");

var _cloudFront = require("../../utils/cloudFront");

var cf_utils = _interopRequireWildcard(_cloudFront);

var _utils = require("./../../utils");

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _polyfluid = require("@quixeltools/quixel-ui-library/dist/utils/polyfluid");

var _utils2 = require("../../EpicMigration/utils");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var plansSection = (0, _glamor.css)({
  paddingTop: "0 !important"
});

var mainDiv = (0, _glamor.css)({
  paddingTop: "13px"
});

var PLAN_YEARLY = "annual";
var PLAN_MONTHLY = "monthly";

var titleCss = (0, _glamor.css)(_fonts.H1, {
  margin: "auto",
  maxWidth: "1280px",
  marginTop: "2em",
  marginBottom: "2em",
  textTransform: "uppercase"
}, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  marginBottom: "2px",
  lineHeight: 1.1
}));

var plansSectionInner = (0, _glamor.css)({
  maxWidth: "84.5em",
  padding: "0 1.5em !important"
}, (0, _css.minWidth)(_css.breakpoints.medium)({
  padding: "0 2em !important"
}));

var plansWrap = (0, _glamor.css)({
  // maxWidth: "84.5em",
  margin: "auto"
}, (0, _css.minWidth)(_css.breakpoints.medium)({
  padding: 0
}), (0, _css.maxWidth)(_css.breakpoints.medium)({
  width: "80%",
  margin: "auto"
}));

var plansColumns = (0, _glamor.css)((0, _css.minWidth)(_css.breakpoints.medium)({
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center"
}));

var plansColumnItem = (0, _glamor.css)({
  width: "320px",
  maxWidth: "320px",
  marginRight: "24px",
  flexBasis: "30%",
  ":last-child": {
    marginRight: 0
  }
}, (0, _css.maxWidth)("1375px")({
  marginBottom: "24px",

  flexBasis: "23%"
}), (0, _css.maxWidth)(_css.breakpoints.large)({
  flexBasis: "30%",
  ":nth-child(3)": {
    marginRight: 0
  }
}), (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  margin: "auto",
  marginTop: "1.5em",

  ":nth-child(3)": {
    marginRight: "auto"
  },
  ":last-child": {
    marginRight: "auto"
  }
}));

var plansDetails = (0, _glamor.css)({
  fontSize: (0, _css.unitRem)(0.75),
  display: "flex",
  flexDirection: "column"
}, (0, _css.minWidth)(_css.breakpoints.large)({
  display: "block"
}));

var plansComparison = (0, _glamor.css)({
  order: 2
}, (0, _css.minWidth)(_css.breakpoints.small)({
  marginTop: "2em"
}), (0, _css.minWidth)(_css.breakpoints.mediumlarge)({
  marginTop: "6em"
}));

var plansFooter = (0, _glamor.css)({
  margin: "auto",
  maxWidth: "42em",
  lineHeight: 1.5,
  color: _css.colors.gray,
  textAlign: "left",
  "& span": {
    fontWeight: 300
  }
}, (0, _polyfluid.polyfluid)({
  marginTop: {
    small: [2.6, 3],
    medium: [2, 3]
  },
  marginBottom: {
    small: [5.25, 6],
    medium: [4, 5]
  }
}), (0, _css.maxWidth)(_css.breakpoints.medium)({
  textAlign: "center"
}), (0, _css.minWidth)(_css.breakpoints.small)({
  textAlign: "center"
}), (0, _css.minWidth)(_css.breakpoints.large)((0, _polyfluid.polyfluid)({
  marginTop: {
    small: [6.2, 7.2],
    medium: [6.2, 7.2],
    large: [6.2, 8.6]
  },
  marginBottom: {
    small: [1, 1.125],
    medium: [1, 1.125],
    large: [1.125, 1.5]
  }
})));

var radioLabel = (0, _glamor.css)({
  color: _css.colors.white,
  marginLeft: (0, _css.unitRem)(3),

  "& .text": {
    display: "inline-block",
    verticalAlign: "middle",

    marginLeft: (0, _css.unitRem)(0.5)
  },

  "&:first-child": {
    marginLeft: 0
  }
});
var companyImages = (0, _glamor.css)({
  width: "100%",
  textAlign: "center",
  paddingTop: "8rem",
  paddingBottom: "7rem",
  "& img": {
    maxWidth: "25%",
    marginBottom: "24px"
  }
}, (0, _css.maxWidth)(_css.breakpoints.medium)({
  "& img": {
    maxWidth: "50%"
  }
}));
var radio = (0, _glamor.css)({
  display: "inline-block",
  verticalAlign: "middle"
});

var needsChoosing = function needsChoosing(license) {
  return _ramda2.default.compose(_ramda2.default.lt(1), _ramda2.default.length, _ramda2.default.filter(_ramda2.default.propEq("license", license)));
};
var selectWrap = (0, _glamor.css)({
  color: _css.colors.gray,

  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",

  marginBottom: (0, _css.unitRem)(0.416),
  "& *": {
    textTransform: "capitalize"
  }
});

var selectOptions = (0, _glamor.css)({
  "& *": {
    textTransform: "capitalize"
  }
});

var select = (0, _glamor.css)({
  backgroundColor: "#252525",
  width: "60%",
  minWidth: "12rem",
  ":hover *": {
    cursor: "pointer"
  },
  border: "2px solid #9c9c9c",
  paddingTop: "2px"
}, (0, _css.minWidth)(_css.breakpoints.mediumSmall)({
  display: "none"
}), (0, _css.maxWidth)(_css.breakpoints.small)({
  width: "72%"
}));

var options = [{
  name: "Billed Annually (save 25%)",
  value: 1
}, {
  name: "Billed Monthly",
  value: 2
}];

var tabs = (0, _glamor.css)({}, (0, _css.maxWidth)(_css.breakpoints.mediumSmall)({
  display: "none"
}));
var pointsWorksSection = (0, _glamor.css)({
  fontSize: (0, _css.unitRem)(0.75),
  color: _css.colors.gray,
  fontWeight: 300,
  lineHeight: 1.5,
  textAlign: "center",
  whiteSpace: "pre-line",

  margin: "auto",
  marginTop: (0, _css.unitRem)(1),
  marginBottom: (0, _css.unitRem)(3),

  padding: "0 0"
}, (0, _css.minWidth)(_css.breakpoints.medium)({
  padding: "0 " + (0, _css.unitRem)(0.5)
}), (0, _css.minWidth)(_css.breakpoints.large)({
  padding: "0 " + (0, _css.unitRem)(1.1)
}));
var main = (0, _glamor.css)({
  display: "flex",
  justifyContent: "space-arround",
  maxWidth: "980px",
  margin: "auto"
}, (0, _css.maxWidth)(_css.breakpoints.medium)({
  flexDirection: "column"
}));
var col = (0, _glamor.css)({
  flexBasis: "50%"
});
var packsWrap = (0, _glamor.css)({
  margin: "auto"
});
var heading = (0, _glamor.css)(_fonts.H6, {
  textTransform: "uppercase",
  textAlign: "left"
}, (0, _polyfluid.polyfluid)({
  paddingTop: {
    small: 2.5,
    medium: [2, 3.125],
    large: [3.125, 3.5]
  },
  paddingBottom: {
    small: 2.5,
    medium: [2, 2.125],
    large: [2.125, 2.5]
  }
}));
var subHeading = (0, _glamor.css)(_fonts.superH2, {
  color: _css.pallets.white,
  textAlign: "center",
  marginBottom: (0, _css.unitRem)(2)
}, (0, _polyfluid.polyfluid)({
  marginTop: {
    small: [3],
    medium: [2],
    large: [2, 2]
  }
}));
var pricingHero = (0, _glamor.css)({
  alignItems: "flex-start",
  // paddingTop: "13.5rem",
  paddingTop: "10rem",
  background: "black"
});
var faqs = [{
  question: "What plan is right for me?",
  answer: "\n    We have some great plans for individuals and for teams of all sizes.  <br><br>\n    <strong style=\"font-weight:600\">Personal:</strong> You are either a hobbyist or you work alone with less than $100,000 USD in annual revenue or funds raised. <br><br>\n    <strong style=\"font-weight:600\">Indie:</strong> Your team works on small to medium projects, and you have up to $2,000,000 USD in annual revenue or funds raised.<br><br>\n    <strong style=\"font-weight:600\">Studio:</strong> Your business works on large projects, and you have $2M USD or higher annual revenue or funds raised. We will help customize a solution, just for you.<br><br>\n    <strong style=\"font-weight:600\">Education:</strong> Are you a student or a teacher? We recommend signing up for the <a style=\"text-decoration:underline;color:#808080\" href=\"https://www.unrealengine.com/en-US/education\" >Unreal Engine for Education</a> program, totally free. You\u2019ll also get access to the Megascans library for free.<br><br>\n    <strong style=\"font-weight:600\">Unlimited Megascans access for Unreal Engine based products:</strong> Just sign in with your Epic Games account to get unlimited access to the Megascans library. This Megascans access is licensed for use with Unreal Engine only and treats Megascans assets as UE-Only Content under the Epic Games Content License Agreement.<br><br>\n  "
}, {
  question: "What is included in my subscription?",
  answer: "Your subscription includes full access to the Quixel Megascans asset library. You also get a free, personalized drop of bonus assets every month based on your usage. These bonus assets are selected just for you, and they get more relevant the more you use Megascans. With your account, you continue your full-featured access to use Quixel Bridge, a content management and integrations solution, and Quixel Mixer, a simple and fast material authoring tool that you can use to create completely customized materials."
}, {
  question: "How do points work?",
  answer: "\n    Your subscription comes with 90 points a month, and when you buy annual you get the entire year\u2019s points upfront, plus 20% bonus points. Points can be used to buy and download assets from the Megascans library.<br><br>\n3D assets cost 4 points each, surfaces cost 2 points each, and an asset of any other type costs just 1 point. On a monthly plan, you can get 22 3D assets or 45 surfaces or 90 assets of any other type each month. Points are refilled at each billing cycle, and if you don\u2019t use your points during one billing period, they carry over to the next one. If you use up all your points and don\u2019t want to wait for your next refill, you can always top-up your points at any time.\n  "
}, {
  question: "How do bonus asset drops work?",
  answer: "\nYour subscription comes with a free bonus reward of 5 premium assets, every month. These bonus assets are selected just for you, and they get more relevant the more you use Megascans.    <br><br>\nYour bonus assets will drop on the date you subscribed. So, if your subscription date is the 25th, your assets will drop on the 25th of each month, even if you have an annual subscription. When your drop is ready, you\u2019ll find these assets in the \u201CFree\u201D tab with a \u201CBonus\u201D label, and you can download them for the entire month until they are replaced with the next bonus drop.  "
}, {
  question: "I changed my mind. Can I change my subscription?",
  answer: "\nYes! You can upgrade or switch plans whenever you need, as long as your business meets the plan\u2019s requirements. You can also temporarily pause your subscription when you need to take a break.\n  "
}, {
  question: "What happens to my assets if my subscription has ended?",
  answer: "\n    You can continue to use assets commercially for your projects once you\u2019ve downloaded them. If you are on an older discontinued plan, please refer to our\n    <a style=\"text-decoration:underline;color:#808080\" href=\"/terms\" >Terms</a> for details.\n  "
}, {
  question: "I am on a plan that is no longer on the site. Will Quixel continue to support my plan?",
  answer: "\nAlthough our legacy plans such as Hobby, Freelancer, ArchViz etc. are no longer for sale on the site if you are subscribed to any of these, you keep your current plan and carry on as usual. If you want to change your subscription to one of our new plans get in touch with us and we\u2019ll make it happen.\n  "
}];
var plugins = [{
  image: cf_utils.cf_testimonials("education.jpg"),
  name: "Educational Program",
  description: "Are you a teacher or school? Enroll today to get free access to Megascans, Bridge and Mixer for your entire classroom. Students, ask your teacher or school admin to sign up and we’ll take it from there.",
  icon: "",
  secondaryLabel: "Apply Now",
  secondaryLink: "",
  linkLable: "learn more",
  link: "/education"
}];
var faqContainer = (0, _glamor.css)({
  backgroundColor: "#000",
  width: "100%",
  height: "100%",
  paddingBottom: "8rem",
  paddingTop: "5.2rem"
});
var _faq = (0, _glamor.css)({
  maxWidth: _css.sizes.innerMaxWidth - 270,
  marginBottom: (0, _css.unitRem)(2),
  width: "80%",
  margin: "auto"
}, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  margin: "auto"
}), (0, _css.minWidth)(_css.breakpoints.mediumlarge)({
  margin: "auto",
  marginBottom: (0, _css.unitRem)(4)
}), (0, _css.minWidth)(_css.breakpoints.xlarge)({
  margin: "auto"
}));
var flag = false;

var cloudfrontImage = function cloudfrontImage(path) {
  return __CLIENT__ ? "https://d3uwib8iif8w1p.cloudfront.net/quixel/home/" + path : "";
};
var cloudfrontIcons = function cloudfrontIcons(path) {
  return __CLIENT__ ? "https://d3uwib8iif8w1p.cloudfront.net/quixel/icons/" + path : "";
};

var Pricing = (_dec = (0, _redial.provideHooks)({
  defer: function defer(_ref) {
    var dispatch = _ref.store.dispatch;

    var plans = dispatch((0, _subscriptions.getSubscriptionPlans)());
    var upgradeParams = dispatch((0, _payments.getUpgradeParams)());
    var customerInfo = dispatch((0, _customer.getCustomer)());
    var user = dispatch(userActions.load());
    return _bluebird2.default.all([plans, upgradeParams, customerInfo, user]); // .then((e)=> {},(e)=> {console.log(e)});
  } // ,
  // defer:({ store: { dispatch } }) => {

  //   return BPromise.all([ customerInfo]); // .then((e)=> {},(e)=> {console.log(e)});
  // }
}), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    subscription: state.user && state.user.subscription,
    plans: state.subscriptions.plans,
    plansDecorated: state.subscriptions.plansDecorated,
    plansDecoratedAnual: state.subscriptions.plansDecoratedAnual,
    customer: state.customer && state.customer.customer,
    archVizPlan: state.subscriptions.archVizPlan,
    businessPlan: state.subscriptions.businessPlan,
    megascansTrial: state.user.megascansTrial,
    loggedIn: state.auth.loggedIn,
    user: state.user,
    logos: state.companyLogos.megascans_wall_logos
  };
}, { initPayment: _payments.initPayment }), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(Pricing, _React$Component);

  function Pricing(props) {
    (0, _classCallCheck3.default)(this, Pricing);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Pricing.__proto__ || (0, _getPrototypeOf2.default)(Pricing)).call(this, props));

    _this.onClickTrailPopup = function (e) {
      e.preventDefault();
      e.stopPropagation();

      this.context.dialogs.custom(_react2.default.createElement(_components.TrialPopup, null));
    };

    _this.onClickHandler = function (e) {
      e.preventDefault();
      e.stopPropagation();

      this.context.dialogs.custom(_react2.default.createElement(_components.EducationProgramContainer, {
        title: "Looking to join the Indie Program?",
        description: "Leave us a note and we will get back to you soon.",
        tag: "education-program",
        initialValues: {
          name: "",
          email: "",
          url: "",
          subject: "Educational Program Application",
          indieMessage: ""
        }
      }));
    };

    _this.yearlyMonthlyToggle = function (plans) {
      return _react2.default.createElement(
        "div",
        {
          style: {
            maxWidth: "640px",
            textAlign: "center",
            margin: "auto",
            marginTop: 38
          }
        },
        _react2.default.createElement(
          "div",
          { className: tabs },
          _react2.default.createElement(
            _Tabs2.default,
            {
              active: _this.state.subscriptionType == PLAN_YEARLY ? 0 : 1,
              onSetActiveTab: function onSetActiveTab(tab) {
                _this.setState({
                  subscriptionType: tab == 0 ? PLAN_YEARLY : PLAN_MONTHLY
                });
              },
              styles: { background: "rgba(95,95,95,0.7)" }
            },
            _react2.default.createElement(_Tabs.Tab, { label: "Billed Annually (save 25%)" }),
            _react2.default.createElement(_Tabs.Tab, { label: "Billed Monthly" })
          )
        ),
        _react2.default.createElement(_Select2.default, {
          thin: true,
          mode: "white",
          className: select,
          options: options,
          onChange: _this.onChange,
          value: options[_this.state.subscriptionType == PLAN_YEARLY ? 0 : 1].value
        })
      );
    };

    _this.renderPlansComparison = function (func) {
      return _react2.default.createElement(
        "div",
        { className: plansComparison },
        _react2.default.createElement(
          "div",
          { className: subHeading },
          "CUSTOM LICENSE"
        ),
        plugins.map(function (plugin, key) {
          var haveSubscription = _this.props.subscription && _this.props.subscription.isActive;
          var hadSubscription = _this.props.subscription && !_this.props.subscription.isActive;
          var isArchViz = plugin.name === "Quixel for Enterprise";
          var currentPlan = haveSubscription && _this.props.subscription.license === "studio";
          var linkLable = "";
          var link = "";
          var _func = func;
          var secondaryFunc = null;

          var _this$props = _this.props,
              initPayment = _this$props.initPayment,
              businessPlan = _this$props.businessPlan,
              archVizPlan = _this$props.archVizPlan,
              loggedIn = _this$props.loggedIn;


          if (currentPlan && isArchViz && (haveSubscription || hadSubscription)) {
            linkLable = "MANAGE ACCOUNT";
            link = "/library/account";
            _func = null;
          } else if (isArchViz && haveSubscription && !currentPlan) {
            linkLable = "LEARN MORE";
            link = "/pricing";
            _func = function _func() {
              if (loggedIn) {
                _this.renderContactUsForm("Looking for a change in plan?", "Leave us a note and we will get back to you soon.", "megascans-subscription-change-request", { email: _this.props.user.email });
              } else {
                _reactRouter.browserHistory.push({
                  pathname: "/login",
                  search: "?returnTo=/pricing#contactUs",
                  state: { modal: true }
                });
              }
            };
          } else if (isArchViz && hadSubscription) {
            linkLable = "SELECT";
            link = plugin.link;
          } else if (hadSubscription || haveSubscription) {
            linkLable = "LEARN MORE";
            link = plugin.link;
          } else {
            linkLable = plugin.linkLable;
            link = plugin.link;
          }

          if (plugin.name === "Business") {
            secondaryFunc = function secondaryFunc() {
              return initPayment(businessPlan[0]);
            };
          }

          if (plugin.name === "Architecture") {
            secondaryFunc = function secondaryFunc() {
              return initPayment(archVizPlan[0]);
            };
          }

          if (plugin.name === "STUDIO LICENSE") {
            secondaryFunc = function secondaryFunc() {
              return _this.context.dialogs.custom(_react2.default.createElement(_components.EnterpriseSubscriptionContainer, {
                title: "Looking for an Enterprise plan?",
                description: "We would be happy to tailor a plan that suits your needs. Leave us a note and we will get back to you soon.",
                tag: "Enterprise-Subscription",
                initialValues: {
                  name: "",
                  email: "",
                  company: "",
                  phone: "",
                  position: "",
                  companyUrl: "",
                  comments: "",
                  industry: "",
                  country: ""
                }
              })).bind(_this);
            };
          }
          if (plugin.name === "Educational Program") {
            secondaryFunc = function secondaryFunc() {
              if (_this.props.loggedIn) {
                _this.renderContactUsFormForEducation("Join the Educational Program!", "Leave us a note and we‘ll get back to you soon.", "educational-subscription", "Education XL", { email: _this.props.user.email });
              } else {
                _reactRouter.browserHistory.push({
                  pathname: "/login",
                  search: "?returnTo=/pricing#educationXL",
                  state: { modal: true }
                });
              }
            };
          }
          if (plugin.name === "Indie Developer Program") {
            secondaryFunc = function secondaryFunc() {
              if (_this.props.loggedIn) {
                _this.context.dialogs.custom(_react2.default.createElement(_components.IndieProgramPopupContainer, {
                  title: "Join the Indie Program!",
                  description: "Leave us a note and we'll get back to you soon.",
                  tag: "indie-program",
                  initialValues: {
                    name: "",
                    email: _this.props.user.email,
                    studio: "",
                    title: "",
                    url: "",
                    artworkUrl: "",
                    subject: "Indie Program Application",
                    comments: "",
                    checkBoxPc: "",
                    checkBoxSmartPhone: "",
                    checkBoxPlayStation: "",
                    checkBoxXbox: "",
                    checkBoxNitendo: "",
                    checkBoxMac: "",
                    checkBoxVr: "",
                    checkBoxOther: "",
                    select: "",
                    teamSize: "",
                    releaseDate: "",
                    checkBoxFunding: "",
                    checkBoxPublisher: ""
                  }
                }));
              } else {
                _reactRouter.browserHistory.push({
                  pathname: "/login",
                  search: "?returnTo=/pricing#indieProgram",
                  state: { modal: true }
                });
              }
            };
          }

          return _react2.default.createElement(
            "div",
            { className: packsWrap, key: key },
            _react2.default.createElement(_ItemWithImageDescriptionAndIcons2.default, {
              logo: cf_utils.cf_icons("megascans_icon_2048_preview.png"),
              img: plugin.image,
              title: plugin.name,
              description: plugin.description,
              primaryLabel: "",
              primaryLink: "",
              secondaryLabel: plugin.secondaryLabel,
              secondaryLink: plugin.secondaryLink,
              secondaryFunc: secondaryFunc,
              icon: plugin.icon,
              linkLable: linkLable,
              link: link,
              onClickHandler: _func,
              size: "128"
            })
          );
        }),
        _react2.default.createElement(
          "div",
          {
            className: (0, _glamor.css)({
              display: "flex",
              justifyContent: "space-around",
              color: _css.colors.gray,
              marginBottom: "5.4375rem",
              marginTop: "41px",
              paddingLeft: "1.5rem",
              paddingRight: "1.5rem",
              alignItems: "center",
              textAlign: "center"
            })
          },
          " ",
          _react2.default.createElement(
            "span",
            { className: _fonts.p3 },
            "Can\u2019t find a plan that fits your needs?",
            _react2.default.createElement(_components.TextButtonLibrary, {
              className: _fonts.p3,
              mode: "normal-small",
              label: "Get in touch",
              onClick: function onClick() {
                if (_this.props.loggedIn) {
                  _this.renderContactUsForm("We are here to help!", "Leave us a note and we will get back to you soon.", "pricing", { email: _this.props.user.email });
                } else {
                  _reactRouter.browserHistory.push({
                    pathname: "/login",
                    search: "?returnTo=/pricing#contactUsHelp",
                    state: { modal: true }
                  });
                }
              }
            }),
            "and we\u2019ll help you find a solution!"
          )
        ),
        _react2.default.createElement(
          "div",
          { className: faqContainer },
          _react2.default.createElement(
            "div",
            { className: (0, _glamor.css)(packsWrap, _faq) },
            _react2.default.createElement(
              "div",
              { className: heading },
              "Frequently asked questions"
            ),
            _react2.default.createElement(_FAQSummary2.default, { questions: faqs })
          )
        )
      );
    };

    _this.renderPlans = function (plansDecorated, plans) {
      var _this$props2 = _this.props,
          subscription = _this$props2.subscription,
          initPayment = _this$props2.initPayment,
          archVizPlan = _this$props2.archVizPlan,
          businessPlan = _this$props2.businessPlan,
          user = _this$props2.user,
          loggedIn = _this$props2.loggedIn;

      var decoratedPlans = _this.state.subscriptionType === PLAN_MONTHLY ? _this.props.plansDecorated : _this.props.plansDecoratedAnual;

      var userSubIsAmongCurrentPlans = subscription && decoratedPlans.find(function (plan) {
        return plan.type === subscription.planId;
      });

      var sub = user.subscription,
          megascansTrial = user.megascansTrial;

      var subscribed = sub && sub.isActive;

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "div",
          { className: plansWrap },
          _react2.default.createElement(
            "div",
            { className: plansColumns },
            decoratedPlans.map(function (plan) {
              if (plans === null) {
                return _react2.default.createElement("div", null);
              }

              var selectTo = _ramda2.default.ifElse(needsChoosing(plan.license), _ramda2.default.always("/choose/" + plan.name.toLowerCase().split(" ")[0]), _ramda2.default.always("/subscribe/" + plan.type))(plans);

              var isSamePlan = subscription && plan.type === subscription.planId;
              var isSameBilling = subscription && plan.billing === subscription.billing;

              var isCurrentPlan = subscription && subscription.isActive && (isSamePlan || plan.license === "custom" && !subscription.doesGetCharged);

              var canUpgrade = subscription && subscription.isActive && subscription.doesGetCharged;

              var canSwitch = subscription && subscription.doesGetCharged && (0, _utils2.isSwitchingAllowed)(subscription.planId);

              var canNotSwitch = !canSwitch;

              if (plan.planType === "business") selectTo = "/business";else if (plan.planType === "archviz") {
                selectTo = "/archviz";
              } else if (plan.type === "unreal") {
                selectTo = {
                  pathname: "/epic-migration",
                  state: { modal: true, fromPricing: true, welcome: true }
                };
              }
              return _react2.default.createElement(
                "div",
                { className: plansColumnItem, key: plan.order },
                _react2.default.createElement(_components.PlanBox, (0, _extends4.default)((0, _defineProperty3.default)({
                  onUpgradeSubscriptionClick: function onUpgradeSubscriptionClick() {
                    _this.onUpgradeSubscriptionClick(subscription);
                  },
                  // logo:
                  //   "https://d3uwib8iif8w1p.cloudfront.net/quixel/icons/megascans_icon_2048_preview.png", //cf_utils.cf_icons('quixel_logo.png'),
                  name: plan.name,
                  desc: plan.desc,
                  subDesc: plan.subDesc,
                  //barColor: 'blue',//plan.name === 'Personal'? 'green':'blue',
                  buttonColor: "blue",
                  isCurrentPlan: isCurrentPlan,
                  learnMoreHref: "",
                  price: plan.billing == "annual" && plan.name !== "Business" ? plan.amount / 12 : plan.amount,
                  pointsPerMonth: plan.billing == PLAN_MONTHLY ? plan.points : null,
                  pointsPerYear: plan.billing == PLAN_YEARLY ? plan.points : null,
                  cycle: plan.billing,
                  upgrade: subscription && canUpgrade && isSamePlan && !isSameBilling && subscription.billing == PLAN_MONTHLY && subscription.planId !== "personal-0-app" && subscription.planId !== "personal-0-annual" && subscription.planId !== "personal-0",
                  subscribed: !!subscription && subscription.isActive,
                  buttonLearnMoreLabel: canSwitch ? "SWITCH PLAN" : null,
                  buttonLearnMoreTo: canSwitch ? selectTo : null,
                  selectTo: selectTo,
                  initializePayment: function initializePayment() {
                    return initPayment(plan, _this.state.subscriptionType);
                  },
                  billing: plan.billing,
                  contactUs: (!isSamePlan || !isSameBilling) && (plan.contactUs || subscription && subscription.isActive),
                  hidePrice: false,
                  borderButton: plan.type !== "unreal",
                  buttonSubscribeLabel: "Get " + (plan.name.toLowerCase() === "unreal engine" ? "unlimited access" : plan.name),
                  buttonContactUsLearnMoreLabel: "Contact us",
                  contactUsDescription: plan.contactUsDescription,
                  marketingPoints: plan.marketingPoints,
                  noPrice: plan.type === "unreal"
                }, "hidePrice", plan.type === "studio"), canNotSwitch && {
                  handleClick: function handleClick() {
                    if (loggedIn) {
                      _this.renderContactUsForm("Looking for a change in plan?", "Leave us a note and we will get back to you soon.", "megascans-subscription-change-request", { email: _this.props.user.email });
                    } else {
                      _reactRouter.browserHistory.push({
                        pathname: "/login",
                        search: "?returnTo=/pricing#contactUs",
                        state: { modal: true }
                      });
                    }
                  }
                }))
              );
            })
          )
        ),
        _react2.default.createElement(
          "div",
          { className: plansDetails },
          _this.renderPlansComparison()
        )
      );
    };

    _this.renderHowPointsWork = function () {
      return _react2.default.createElement(_HowPointsWork2.default, {
        assetTypes: [{
          title: "3D Models",
          imgSrc: "/images/pricing/points-3d.png",
          points: "3-12"
        }, {
          title: "Vegetation",
          imgSrc: "/images/pricing/points-vegetation.png",
          points: "1-2"
        }, {
          title: "Surfaces",
          imgSrc: "/images/pricing/points-surfaces.png",
          points: "1-4"
        }],
        detailPoints: [{
          title: "Yours Forever",
          description: "Use your downloaded assets for free, as long as you're on an active subscription."
        }, {
          title: "Re-download for Free",
          description: "Re-download assets you’ve already bought free of charge at any time."
        }, {
          title: "Add Points Anytime",
          description: "Add more points to your subscription at any time from within your account."
        }]
      });
    };

    _this.renderContent = function (plansDecorated, plans) {
      return _react2.default.createElement(
        "div",
        { className: mainDiv },
        _react2.default.createElement(
          "div",
          null,
          _this.renderPlans(plansDecorated, plans),
          _react2.default.createElement(_CompanyListing2.default, {
            title: "You're in great company",
            subHeading: "OUR CUSTOMERS",
            subtitle1: "Quixel\u2019s tools have already been adopted by thousands of happy companies and customers",
            subtitle2: " to help shape some of the biggest games and movies of the last year.",
            clients: _this.props.logos
          })
        )
      );
    };

    _this.onUpgradeSubscriptionClick = _this.onUpgradeSubscriptionClick.bind(_this);
    _this.onChange = _this.onChange.bind(_this);
    _this.onClickTrailPopup = _this.onClickTrailPopup.bind(_this);
    _this.onClickHandler = _this.onClickHandler.bind(_this);
    _this.state = {
      subscriptionType: props.subscription ? props.subscription.billing : PLAN_YEARLY,
      isOpened: false
    };
    return _this;
  }

  (0, _createClass3.default)(Pricing, [{
    key: "renderContactUsFormForEducation",
    value: function renderContactUsFormForEducation(title, description, tag, type, initialValues) {
      this.context.dialogs.custom(_react2.default.createElement(_components.EducationSubscriptionContainer, {
        title: title,
        description: description,
        tag: tag,
        label: type !== "Education Free" && (this.props.subscription && !this.props.subscription.isActive || !this.props.subscription) ? "CONTINUE" : "SEND",
        initialValues: {
          name: "",
          email: initialValues.email,
          url: "",
          subject: "Educational Program Application",
          indieMessage: "",
          duration: "",
          type: type
        }
      }));
    }
  }, {
    key: "onChange",
    value: function onChange(e) {
      e.preventDefault();
      var value = e.target.value - 1;
      this.setState({
        subscriptionType: value == 0 ? PLAN_YEARLY : PLAN_MONTHLY
      });
    }
  }, {
    key: "renderContactUsForm",
    value: function renderContactUsForm(title, description, tag, initialValues) {
      this.context.dialogs.custom(_react2.default.createElement(_components.ContactUsPopupContainer, {
        title: title,
        description: description,
        tag: tag,
        initialValues: {
          name: _ramda2.default.propOr("", "name", initialValues),
          email: _ramda2.default.propOr("", "email", initialValues),
          subject: _ramda2.default.propOr("", "subject", initialValues),
          comment: _ramda2.default.propOr("", "comment", initialValues)
        }
      }));
    }
  }, {
    key: "onUpgradeSubscriptionClick",
    value: function onUpgradeSubscriptionClick(subscription) {
      var dialogs = this.context.dialogs;

      var props = this.props;
      if (_payments.upgradeablePlanIds.indexOf(subscription.planId) === -1) {
        dialogs.custom(_react2.default.createElement(_components.ContactUsPopupContainer, {
          title: "Looking for a change in plan?",
          description: "Leave us a note and we will get back to you soon.",
          tag: "megascans-subscription-monthlyToAnnual-switch-request",
          initialValues: {
            name: _ramda2.default.propOr("", "name", props.customer),
            email: _ramda2.default.propOr("", "user", props.customer),
            subject: _ramda2.default.propOr("Request for switching monthly subscription to Annual Plan", "subject", subscription),
            comment: _ramda2.default.propOr("", "comment", subscription)
          }
        }));
      } else {
        dialogs.custom(_react2.default.createElement(_components.UpgradeSubscriptionPopup, null));
      }
    }
  }, {
    key: "renderSubSections",
    value: function renderSubSections() {
      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "div",
          { className: main },
          _react2.default.createElement(
            "div",
            { className: col },
            _react2.default.createElement(
              "div",
              {
                className: (0, _glamor.css)({
                  maxWidth: _css.sizes.innerMaxWidthTight,
                  margin: (0, _css.unitRem)(1.1) + " auto"
                })
              },
              _react2.default.createElement(
                "h1",
                {
                  className: (0, _glamor.css)({
                    fontSize: (0, _css.unitRem)(1.25),
                    fontWeight: 300,
                    lineHeight: 1.5,
                    textAlign: "center"
                  }, (0, _css.maxWidth)(_css.breakpoints.medium)({
                    fontSize: (0, _css.unitRem)(1)
                  }))
                },
                "Add Points Anytime"
              ),
              _react2.default.createElement(
                "p",
                { className: pointsWorksSection },
                "Add more points to your subscription at any time from within your account."
              )
            )
          ),
          _react2.default.createElement(
            "div",
            { className: col },
            _react2.default.createElement(
              "div",
              {
                className: (0, _glamor.css)({
                  maxWidth: _css.sizes.innerMaxWidthTight,
                  margin: (0, _css.unitRem)(1.1) + " auto"
                })
              },
              _react2.default.createElement(
                "h1",
                {
                  className: (0, _glamor.css)({
                    fontSize: (0, _css.unitRem)(1.25),
                    fontWeight: 300,
                    lineHeight: 1.5,
                    textAlign: "center"
                  }, (0, _css.maxWidth)(_css.breakpoints.medium)({
                    fontSize: (0, _css.unitRem)(1)
                  }))
                },
                "Yours Forever"
              ),
              _react2.default.createElement(
                "p",
                { className: pointsWorksSection },
                "Use your downloaded assets for free, as long as you're on an active subscription."
              )
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: main },
          _react2.default.createElement(
            "div",
            { className: col },
            _react2.default.createElement(
              "div",
              {
                className: (0, _glamor.css)({
                  maxWidth: _css.sizes.innerMaxWidthTight,
                  margin: (0, _css.unitRem)(1.1) + " auto"
                })
              },
              _react2.default.createElement(
                "h1",
                {
                  className: (0, _glamor.css)({
                    fontSize: (0, _css.unitRem)(1.25),
                    fontWeight: 300,
                    lineHeight: 1.5,
                    textAlign: "center"
                  }, (0, _css.maxWidth)(_css.breakpoints.medium)({
                    fontSize: (0, _css.unitRem)(1)
                  }))
                },
                "Re-download Assets for Free"
              ),
              _react2.default.createElement(
                "p",
                { className: pointsWorksSection },
                "Re-download assets that you have already bought, free of charge at any time."
              )
            )
          ),
          _react2.default.createElement(
            "div",
            { className: col },
            _react2.default.createElement(
              "div",
              {
                className: (0, _glamor.css)({
                  maxWidth: _css.sizes.innerMaxWidthTight,
                  margin: (0, _css.unitRem)(1.1) + " auto"
                })
              },
              _react2.default.createElement(
                "h1",
                {
                  className: (0, _glamor.css)({
                    fontSize: (0, _css.unitRem)(1.25),
                    fontWeight: 300,
                    lineHeight: 1.5,
                    textAlign: "center"
                  }, (0, _css.maxWidth)(_css.breakpoints.medium)({
                    fontSize: (0, _css.unitRem)(1)
                  }))
                },
                "Points are Carried Over"
              ),
              _react2.default.createElement(
                "p",
                { className: pointsWorksSection },
                "Left over points from each month / year get carried over to the next."
              )
            )
          )
        )
      );
    }
  }, {
    key: "renderPointsWorksSection",
    value: function renderPointsWorksSection() {
      return _react2.default.createElement(_Section2.default, {
        headerClassName: (0, _glamor.css)({ marginBottom: (0, _css.unitRem)(2) }),
        title: "How do points work?",
        hr: true,
        subTitle: _react2.default.createElement(
          "span",
          { className: (0, _glamor.css)({ fontSize: (0, _css.unitRem)(0.75) }) },
          "Your subscription comes with a set number of points that you can use to download content. Your points get refilled monthly / annually depending on your subscription and all unused points stay in your wallet forever."
        ),
        content: this.renderSubSections()
      });
    }
  }, {
    key: "contactUsRenderContainer",
    value: function contactUsRenderContainer(hash, loggedIn, email) {
      if (hash === "educationXL" && !this.state.isOpened) {
        if (loggedIn) {
          this.setState({
            isOpened: true
          });
          this.renderContactUsFormForEducation("Join the Educational Program!", "Leave us a note and we‘ll get back to you soon.", "educational-subscription", "Education XL", { email: email });
        } else {
          _reactRouter.browserHistory.push({
            pathname: "/login",
            search: "?returnTo=/pricing#educationXL",
            state: { modal: true }
          });
        }
      } else if (hash === "indieProgram" && !this.state.isOpened) {
        if (loggedIn) {
          this.setState({
            isOpened: true
          });
          this.context.dialogs.custom(_react2.default.createElement(_components.IndieProgramPopupContainer, {
            title: "Join the Indie Program!",
            description: "Leave us a note and we'll get back to you soon.",
            tag: "indie-program",
            initialValues: {
              name: "",
              email: email,
              studio: "",
              title: "",
              url: "",
              artworkUrl: "",
              subject: "Indie Program Application",
              comments: "",
              checkBoxPc: "",
              checkBoxSmartPhone: "",
              checkBoxPlayStation: "",
              checkBoxXbox: "",
              checkBoxNitendo: "",
              checkBoxMac: "",
              checkBoxVr: "",
              checkBoxOther: "",
              select: "",
              teamSize: "",
              releaseDate: "",
              checkBoxFunding: "",
              checkBoxPublisher: ""
            }
          }));
        } else {
          _reactRouter.browserHistory.push({
            pathname: "/login",
            search: "?returnTo=/pricing#indieProgram",
            state: { modal: true }
          });
        }
      } else if (hash === "contactUsHelp" && !this.state.isOpened) {
        if (loggedIn) {
          this.setState({
            isOpened: true
          });
          this.renderContactUsForm("We are here to help!", "Leave us a note and we will get back to you soon.", "pricing", { email: email });
        } else {
          _reactRouter.browserHistory.push({
            pathname: "/login",
            search: "?returnTo=/pricing#contactUsHelp",
            state: { modal: true }
          });
        }
      } else if (hash === "contactUs" && !this.state.isOpened) {
        if (loggedIn) {
          this.setState({
            isOpened: true
          });
          this.renderContactUsForm("Looking for a change in plan?", "Leave us a note and we will get back to you soon.", "megascans-subscription-change-request", { email: email });
        } else {
          _reactRouter.browserHistory.push({
            pathname: "/login",
            search: "?returnTo=/pricing#contactUs",
            state: { modal: true }
          });
        }
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.user !== this.props.user) {
        var hash = nextProps.location.hash;
        if (hash && hash.length) {
          if (hash.indexOf("#") == 0) {
            hash = hash.slice(1);
          }
          this.contactUsRenderContainer(hash, nextProps.loggedIn, nextProps.user.email);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          plans = _props.plans,
          plansDecorated = _props.plansDecorated,
          subscription = _props.subscription,
          user = _props.user;

      // const switchingToUUNotAllowed = isSwitchingToUUNotAllowed(subscription);

      return _react2.default.createElement(
        _components.AppSideEffects,
        {
          documentTitle: "- Free for use with Unreal Engine, affordable licenses for all",
          documentImage: cf_utils.cf_thumbs("page-thumb-pricing.jpg"),
          documentDescription: "Quixel Megascans is free for use with Unreal Engine. Log in with your Epic Games account for unlimited access."
        },
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "div",
            { id: "unreal-unlimited" },
            _react2.default.createElement(_components.UnrealUnlimitedBanner, {
              backgroundVideo: {
                poster: cf_utils.cf_qx_page("home", "unlimitedaccess-loop-FALLBACK.jpg"),
                loop: "true",
                src: cf_utils.cf_qx_page("home", "unlimitedaccess-loop-compressed.mp4")
              },
              user: user,
              title: "Unlimited Megascans access<br>for use with Unreal Engine",
              subTitle: "If you have a Content License, simply sign in with your Epic Games<br>account to get unlimited access to the Megascans library through Bridge.*",
              message: "*This Megascans access is licensed for use with Unreal Engine-based products only and treats Megascans<br>assets as Epic Games Content under the Content License Agreement.<br><br>",
              secondaryLabel: "begin for free",
              link: {
                label: "Learn More",
                to: "https://help.quixel.com/hc/en-us/sections/360000977797",
                target: "_blank",
                rel: "noreferrer"
              }
            })
          ),
          _react2.default.createElement(
            "div",
            {
              className: (0, _glamor.css)({
                position: "relative",
                textAlign: "center",
                color: _css.colors.white,
                width: "100%",
                zIndex: 1
              })
            },
            _react2.default.createElement(
              "h1",
              { className: titleCss },
              "Choose Your Plan"
            ),
            this.renderContent(plansDecorated, plans)
          )
        )
      );
    }
  }]);
  return Pricing;
}(_react2.default.Component), _class2.contextTypes = {
  router: _react2.default.PropTypes.object,
  dialogs: _react2.default.PropTypes.object
}, _temp)) || _class) || _class);
exports.default = Pricing;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/Pricing2/Pricing.jsx
// module id = 2919
// module chunks = 0